<template>
    <section class="px-content py-20 xl:pt-[120px] xl:pb-56 will-change bg-light-blue-03" :data-scroll-section="inner == 'false'">
        <div class="flex flex-col items-center text-center  mb-12 xl:mb-20 will-change" data-scroll data-scroll-class="xyz-in" xyz="fade down duration-15">
            <h2  class="text-4xl  xl:text-heading mb-8" v-show="blockData.title">{{ blockData.title }}</h2>
            <div class="xl:max-w-[40vw] leading-normal" v-show="blockData.text" v-html="blockData.text"></div>
        </div>

        <div class="timeline-wrap grid grid-cols-1 md:grid-cols-2 justify-items-center  mx-auto relative w-full xl:w-[1194px]">

            <!-- timeline cards -->
            <XyzTransitionGroup appear-visible class="time-card mb-14 md:mb-0 relative w-full md:w-[384px] will-change" v-show="blockData.cards" v-for="(card, index) in blockData.cards" :key="index" xyz="delay-1 fade duration-20">
                <div class="text-sm tracking-desk font-medium uppercase mb-5" v-show="card.title" :key="index+card.title">{{ card.title }}</div>
                <div class="overflow-hidden" :key="'div'+index" data-scroll data-scroll-speed=".5" data-scroll-delay=".5">
                    <img v-show="card.image" :src="card.image.url" :alt="card.image.alt">
                </div>
                <div class="mt-7 leading-normal" v-show="card.text" v-html="card.text" :key="index+card.text"></div>

                <div class="date hidden md:grid place-content-center absolute top-1/2 -translate-y-full w-14 h-32 " v-show="card.year" :key="index+card.year" data-scroll data-scroll-repeat="true" data-scroll-offset="20%, 58%" data-scroll-class="active">
                    <span class="bg-navy-blue-01 block rounded-full w-4 h-4 transition"  ></span>
                </div>
            </XyzTransitionGroup>
            <!-- ./timeline cards -->

            <div id="timeline" class="hidden md:block absolute left-1/2 -translate-x-1/2 top-28 w-[1.5px] h-[calc(100%+5rem)] z-[-1]"></div>

        </div>
    </section>
</template>


<script>
    export default {
        name: 'TimelineCards',
        data() {
            return {}
        },
        mounted() {
            
        },
        methods: {

        },
    }
</script>

<style scoped>
.add-border {
    border: 5px solid red;
}
</style>
